module.exports = __webpack_public_path__ + "static/media/1024x1024.afd97326.png";